import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('certificates.routes.index'),
        name: 'certificates',
        component: () =>
            import(
                /* webpackChunkName: "certificates" */ '@/views/certificates/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            showName: 'Dashboard',
            breadcrumb: [
                {
                    text: i18n.t('certificates.breadcrumbs.index'),
                    to: { name: 'certificates' },
                    disable: false,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('certificates.routes.create'),
        name: 'certificates.create',
        component: () =>
            import(
                /* webpackChunkName: "certificates" */ '@/views/certificates/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            showName: 'Dashboard',
            breadcrumb: [
                {
                    text: i18n.t('certificates.breadcrumbs.index'),
                    to: { name: 'certificates' },
                    disable: false,
                },
                {
                    text: i18n.t('certificates.breadcrumbs.create'),
                    to: { name: 'certificates.create' },
                    disable: true,
                },
            ],
        },
    },
]
